declare global {
    interface Window { ftStallMark?: (label: string) => void; ftStallWatchdogReady?: boolean }
}

/** Stateless bridge: each bundle observes the watchdog owned by this window. */
export function markStall(label: string): void {
    try { if (typeof window !== 'undefined') window.ftStallMark?.(label); } catch { /* Observer only. */ }
}
